import { render } from "./section-two.vue?vue&type=template&id=08290a8b&scoped=true"
import script from "./section-two.vue?vue&type=script&lang=js"
export * from "./section-two.vue?vue&type=script&lang=js"

import "./section-two.vue?vue&type=style&index=0&id=08290a8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08290a8b"]])

export default __exports__